export default {
    CalendarPublishingUnpublish: {
        name: 'CALENDARPUBLISHING_UNPUBLISH',
    },
    CalendarPublishingResetLinks: {
        name: 'CALENDARPUBLISHING_RESETLINKS',
    },
};
